import React, { useState, useEffect } from 'react';
import 'Application/Templates/Css/Components/Fullscreen.css';

const FullscreenComponent = () => {
    const [isFullscreen, setIsFullscreen] = useState(false);

    // Vérifier l'état du plein écran quand le composant est monté
    useEffect(() => {
        const handleFullscreenChange = () => {
            const fullscreenElement = 
                document.fullscreenElement || 
                document.mozFullScreenElement || 
                document.webkitFullscreenElement || 
                document.msFullscreenElement;
            
            setIsFullscreen(!!fullscreenElement);
        };

        // Vérification initiale au montage
        handleFullscreenChange();

        document.addEventListener('fullscreenchange', handleFullscreenChange);
        document.addEventListener('mozfullscreenchange', handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
        document.addEventListener('MSFullscreenChange', handleFullscreenChange);

        return () => {
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
            document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
            document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
            document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
        };
    }, []);

    const toggleFullscreen = () => {
        if (!isFullscreen) {
            // Activer le plein écran
            const elem = document.documentElement;
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.mozRequestFullScreen) { // Firefox
                elem.mozRequestFullScreen();
            } else if (elem.webkitRequestFullscreen) { // Chrome, Safari and Opera
                elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) { // IE/Edge
                elem.msRequestFullscreen();
            }
        } else {
            // Désactiver le plein écran
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) { // Firefox
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) { // Chrome, Safari and Opera
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) { // IE/Edge
                document.msExitFullscreen();
            }
        }
    };

    return (
        <button onClick={toggleFullscreen} className='icon-button hide-mobile' id='fullscreenButton'>
            <img 
                src={isFullscreen ? 'fullscreenOn.png' : 'fullscreenOff.png'} 
                alt={isFullscreen ? "Quitter le plein écran" : "Activer le plein écran"} 
            />
        </button>
    );
};

export default FullscreenComponent;